import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/page_turning_left_white.svg'
import _imports_1 from '../assets/images/page_turning_right_white.svg'
import _imports_2 from '../assets/images/add_manager_icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-e6c91074"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-wrapper" }
const _hoisted_2 = { class: "management_center_bg" }
const _hoisted_3 = { class: "top_manager_view" }
const _hoisted_4 = { class: "manager_center_view_bg" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "manager_center_tips" }, "管理中心", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "edit_info_tips" }, "编辑账号信息", -1))
const _hoisted_7 = { class: "center_content_view" }
const _hoisted_8 = { class: "left_view" }
const _hoisted_9 = { class: "linkard_limit_title_bg" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "linkard_limit_title" }, "联卡额度", -1))
const _hoisted_11 = { class: "linkard_limit_title_right_bg" }
const _hoisted_12 = { class: "count_tips" }
const _hoisted_13 = { class: "linkard_limit_list_bg" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"linkard_limit_list_title_bg\" data-v-e6c91074><span class=\"linkard_name_title\" data-v-e6c91074>联卡名称</span><span class=\"link_url_title\" data-v-e6c91074>联卡链接</span><span class=\"dialogue_use_title\" data-v-e6c91074>对话消耗</span><span class=\"manager_user_name_title\" data-v-e6c91074>管理员</span></div>", 1)
const _hoisted_15 = { class: "linkard_limit_list" }
const _hoisted_16 = { class: "linkard_limit_item" }
const _hoisted_17 = { class: "linkard_name" }
const _hoisted_18 = { class: "link_url" }
const _hoisted_19 = { class: "dialogue_use" }
const _hoisted_20 = { class: "manager_user_name" }
const _hoisted_21 = { class: "linkard_limit_list_bottom_view" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_23 = { class: "page_number" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_25 = {
  ref: "rightContentView",
  class: "right_view"
}
const _hoisted_26 = { class: "manager_list_title_bg" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "manager_list_title" }, "权限管理", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "add_icon",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "添加", -1))
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "manager_list_bg" }
const _hoisted_32 = { class: "manager_list" }
const _hoisted_33 = { class: "manager_list_item" }
const _hoisted_34 = { class: "user_name" }
const _hoisted_35 = { class: "user_phone" }
const _hoisted_36 = {
  key: 2,
  class: "delete_button_placehoder"
}
const _hoisted_37 = { class: "manager_list_bottom_view" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_39 = { class: "page_number" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_41 = {
  key: 0,
  class: "regular_administrator_tips"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_AddManagerView = _resolveComponent("AddManagerView")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_DeleteManagerView = _resolveComponent("DeleteManagerView")!
  const _component_EnterpriseEditUserInfoView = _resolveComponent("EnterpriseEditUserInfoView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: _normalizeClass(['version_type_default', _ctx.userLevel == 4 ? 'version_type_ent' : 'version_type_other'])
          }, _toDisplayString(_ctx.userLevelTips), 3)
        ]),
        _createElementVNode("button", {
          class: "edit_button_bg",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.enterpriseEditUserInfoClick && _ctx.enterpriseEditUserInfoClick(...args)))
        }, [
          _hoisted_6,
          (_ctx.userLevel == 4)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(['authority_type', _ctx.isEnterpriseAdmin ? 'authority_type_admin' : ''])
              }, _toDisplayString(_ctx.isEnterpriseAdmin ? '超管' : '普管'), 3))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, "已建" + _toDisplayString(_ctx.linkardLimitInfo.linkardNum) + "张 / 剩余可用" + _toDisplayString(_ctx.linkardLimitInfo.linkardTotal - _ctx.linkardLimitInfo.linkardNum) + "张", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("ul", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempLinkardLimitList, (limitItem, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(limitItem.name), 1),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.baseUrl + '/' + limitItem.link), 1),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(limitItem.usedCnt + "/" + (limitItem.remainingCnt +
                        limitItem.usedCnt)), 1),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(limitItem.adminName), 1)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_el_button, {
                disabled: _ctx.currentLinkardLimitPage <= 0,
                class: "page_button",
                onClick: _ctx.pageLeft
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.currentLinkardLimitPage + 1), 1),
              _createVNode(_component_el_button, {
                disabled: (_ctx.currentLinkardLimitPage + 1) * 5 >= _ctx.linkardLimitInfo.linkardLimitList.length,
                class: "page_button",
                onClick: _ctx.pageRight
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            (_ctx.isEnterpriseAdmin)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  class: "add_manager_user_button",
                  onClick: _ctx.addManagerUserButtonClick
                }, {
                  default: _withCtx(() => [
                    _hoisted_28,
                    _hoisted_29
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_30))
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("ul", _hoisted_32, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempManagerList, (managerItem, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("span", _hoisted_34, _toDisplayString(managerItem.userName), 1),
                    (_ctx.userLevel == 4)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(['authority_type', managerItem.isEnterpriseAdmin ? 'authority_type_admin' : ''])
                        }, _toDisplayString(managerItem.isEnterpriseAdmin ? '超管' : '普管'), 3))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_35, _toDisplayString(managerItem.encryptUserPhone), 1),
                    (!managerItem.isEnterpriseAdmin)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          disabled: !_ctx.isEnterpriseAdmin,
                          class: "delete_button",
                          onClick: ($event: any) => (_ctx.deleteManagerUserButtonClick(managerItem))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("删除")
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_36))
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createVNode(_component_el_button, {
                disabled: _ctx.managerListPage <= 0,
                class: "page_button",
                onClick: _ctx.managerPageLeft
              }, {
                default: _withCtx(() => [
                  _hoisted_38
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.managerListPage + 1), 1),
              _createVNode(_component_el_button, {
                disabled: (_ctx.managerListPage + 1) * 5 >= _ctx.managerList.length,
                class: "page_button",
                onClick: _ctx.managerPageRight
              }, {
                default: _withCtx(() => [
                  _hoisted_40
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ]),
          (!_ctx.isEnterpriseAdmin)
            ? (_openBlock(), _createElementBlock("span", _hoisted_41, "普通管理员无法修改权限"))
            : _createCommentVNode("", true)
        ], 512)
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showAddManagerView,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showAddManagerView) = $event)),
      "show-close": false,
      "align-center": "",
      center: ""
    }, {
      header: _withCtx(() => [
        _createVNode(_component_AddManagerView, {
          dialogText: "添加普通管理员",
          onDismissAddManagerView: _ctx.dismissAddManagerView
        }, null, 8, ["onDismissAddManagerView"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showDeleteManagerView,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showDeleteManagerView) = $event)),
      "show-close": false,
      "align-center": "",
      center: ""
    }, {
      header: _withCtx(() => [
        _createVNode(_component_DeleteManagerView, { onDismissDeleteManagerView: _ctx.dismissDeleteManagerView }, null, 8, ["onDismissDeleteManagerView"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showEnterpriseEditUserInfoView,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showEnterpriseEditUserInfoView) = $event)),
      "show-close": false,
      "align-center": "",
      center: ""
    }, {
      header: _withCtx(() => [
        _createVNode(_component_EnterpriseEditUserInfoView, { onDismissEnterpriseEditUserInfoView: _ctx.dismissEnterpriseEditUserInfoView }, null, 8, ["onDismissEnterpriseEditUserInfoView"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}